// extracted by mini-css-extract-plugin
export default {"layout":"bb7cd3946b _307c2c5714 df74f4ac25","h_slide":"_20c34ca800","category":"_67d0c3105c eed231034b _72a741ee5d"};